import { render } from "./Create.vue?vue&type=template&id=77a6a0c7"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/User/Create.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77a6a0c7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77a6a0c7', __exports__)) {
    console.log('reload')
    api.reload('77a6a0c7', __exports__)
  }
  
  module.hot.accept("./Create.vue?vue&type=template&id=77a6a0c7", () => {
    console.log('re-render')
    api.rerender('77a6a0c7', render)
  })

}


export default __exports__